const freeSignup = {
  SIGNUP_FREE_TRIAL: 'SIGNUP_FREE_TRIAL',
};

export default freeSignup;
